import React from 'react';
import AnimatedText from 'react-animated-text-content';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Col, Container, Row } from 'react-bootstrap';
import { ArrowDown } from 'react-bootstrap-icons';
import AgencyImg from '../../assets/images/agency-img.jpg';
import { HashLink } from 'react-router-hash-link';
import './agency.css';

const Agency = () => {
  return (
    <Container fluid className='agencyContainer'>
      <Container>
        <h2 className='agency__main__heading'>
          <AnimatedText
            type='chars' // animate words or chars
            animation={{
              x: '200px',
              y: '-20px',
              scale: 1.1,
              ease: 'ease-in-out',
            }}
            animationType='throw'
            interval={0.06}
            duration={1}
            tag='p'
            className='animated-paragraph'
            includeWhiteSpaces
            threshold={0.1}
            rootMargin='20%'
          >
            COLLABORATIONS
          </AnimatedText>
        </h2>
        <p className='agency__p1__top'>
          Our motive is to remove plastic from the world and oceans. That is why
          we have collaborated with top-notch labels to help us restore the
          beauty of the world.
        </p>

        <Row>
          <Col md={12}>
            <h1 className='agency__h1 '>
              OCEAN VOYAGES INSTITUTE SETS SAIL FOR GREAT PACIFIC GARBAGE PATCH
              AMID CLIMATE EMERGENCY
            </h1>

            <p className='agency__p1'>
              The agency's mission is exactly in line with ours, and we
              appreciate the opportunity to provide support until the launch of
              our operation. With your assistance, we will gather plastic and
              save the Oceans.
            </p>
            <div className='button__wrap'>
              <button className='btn__agency'>
                <a
                  href='https://www.oceanvoyagesinstitute.org/'
                  rel='noreferrer'
                  target='_blank'
                >
                  VISIT WEBSITE
                </a>
              </button>
            </div>
          </Col>
        </Row>
        <AnimationOnScroll animateIn='animate__slideInUp'>
          <Row>
            <Col>
              <img
                src={AgencyImg}
                alt='agency group '
                width='100%'
                className='agency__img'
              />
            </Col>
          </Row>
        </AnimationOnScroll>
      </Container>
    </Container>
  );
};

export default Agency;
